// Funciones de Firebase Storage: subir archivos e imágenes y leer metadatos.
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import { auth } from "@/firebase";
import {
  ref,
  getStorage,
  getDownloadURL,
  uploadString,
  getMetadata,
  listAll,
} from "firebase/storage";

export const funcionesStorage = {
  obtenerCustomMetadataStorage(esEliminado) {
    if (esEliminado) {
      return {
        deleteByUid: auth.currentUser.uid || "",
        deleteByEmail: auth.currentUser.email || "",
      };
    }
    return {
      uploadByUid: auth.currentUser.uid || "",
      uploadByEmail: auth.currentUser.email || "",
    };
  },
  // PROCESAR IMAGENES BASE 64 OPTIMIZADO PARA DISPOSITIVOS DE BAJA MEMORIA RAM
  async procesarImagenesBase64(file) {
    const maxDim = 1024;
    const calidad = 0.6;

    // Intentar método nativo createImageBitmap (sin saturar memoria en JS)
    if (typeof createImageBitmap === "function") {
      try {
        const bitmap = await createImageBitmap(file);
        let w = bitmap.width;
        let h = bitmap.height;

        if (w > maxDim || h > maxDim) {
          if (w > h) {
            h = Math.round((h * maxDim) / w);
            w = maxDim;
          } else {
            w = Math.round((w * maxDim) / h);
            h = maxDim;
          }
        }

        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(bitmap, 0, 0, w, h);
        if (bitmap.close) {
          bitmap.close();
        }

        const base64 = canvas.toDataURL("image/jpeg", calidad);
        // Liberar buffer gráfico inmediatamente
        canvas.width = 0;
        canvas.height = 0;
        return base64;
      } catch (bitmapError) {
        console.warn("createImageBitmap no disponible o falló, usando fallback de Canvas:", bitmapError);
      }
    }

    // Fallback estándar optimizado con limpieza de memoria
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          let w = img.width;
          let h = img.height;

          if (w > maxDim || h > maxDim) {
            if (w > h) {
              h = Math.round((h * maxDim) / w);
              w = maxDim;
            } else {
              w = Math.round((w * maxDim) / h);
              h = maxDim;
            }
          }

          const canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, w, h);

          const base64 = canvas.toDataURL("image/jpeg", calidad);

          // Liberación inmediata de RAM
          canvas.width = 0;
          canvas.height = 0;
          img.src = "";
          img.onload = null;
          img.onerror = null;

          resolve(base64);
        };

        img.onerror = (err) => {
          img.onload = null;
          img.onerror = null;
          reject(new Error("Error al cargar la imagen: " + (err ? err.message : "")));
        };

        img.src = event.target.result;
      };

      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  },
  // Funciones de acciones recurrentes
  async subirArchivoBase64(referencia, url) {
    const customMetadata = this.obtenerCustomMetadataStorage(false);
    const metadata = {
      customMetadata: customMetadata,
    };
    const snapshot = await uploadString(
      referencia,
      url,
      "data_url",
      metadata,
    );
    const urlResult = await getDownloadURL(snapshot.ref);
    return urlResult ? urlResult : null;
  },
  async existeCarpetaStorage(ruta) {
    const storage = getStorage();
    const carpetaRef = ref(storage, ruta);
    try {
      const res = await listAll(carpetaRef);
      return res.items.length > 0 || res.prefixes.length > 0;
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  async obtenerMetadataStorage(url) {
    if (!url) return null;
    if (!this._cacheMetadataStorage) {
      this._cacheMetadataStorage = new Map();
    }
    if (this._cacheMetadataStorage.has(url)) {
      return this._cacheMetadataStorage.get(url);
    }
    let metadata = null;
    const storage = getStorage();
    const refFile = ref(storage, url);
    await getMetadata(refFile)
      .then((data) => {
        metadata = data;
        if (data) this._cacheMetadataStorage.set(url, data);
      })
      .catch(() => {
        metadata = null;
      });
    return metadata;
  },
};
